export default __webpack_public_path__ + "static/media/FG_48.0a80c213.png";